import {RoleNames} from '@app/core/enums/roles.enum';
import {RdsIconName} from '@rds/angular-components';

export interface MenuItem {
  icon: RdsIconName;
  title: string;
  path: string;
  roles?: Array<RoleNames>;
  hide?: boolean;
  blocked?: boolean;
}

export const MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Catalog entry (linked pages)',
    icon: 'edit',
    path: '/catalog/entry/create',
    roles: [],
    hide: true,
    blocked: false
  }, {
    title: 'News',
    icon: 'document',
    path: '/news/create',
    roles: [],
    hide: true,
    blocked: false
  }, {
    title: 'Channel',
    icon: 'wifi_on',
    path: '/channels/create',
    roles: [],
    hide: true,
    blocked: false
  },
  {
    title: 'Newsletter',
    icon: 'email',
    path: '/newsletter/newsletter/create',
    roles: []
  }, {
    title: 'Event',
    icon: 'calendar',
    path: '/managing-events/create',
    roles: [],
    hide: true,
    blocked: false
  },
  {
    title: 'Ticker',
    icon: 'high_priority',
    path: '/ticker/create',
    roles: [RoleNames.ADMINISTRATOR],
    hide: true,
    blocked: false
  },
  {
    title: 'Alert',
    icon: 'warning_hex',
    path: '/alerts',
    roles: [RoleNames.ADMINISTRATOR],
    hide: true,
    blocked: false
  }];
